var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"ai-generated-label",class:_vm.variant,attrs:{"src":_vm.source,"alt":_vm.$gettext('AI-generated')}})
}
var staticRenderFns = []

export { render, staticRenderFns }